import { CATMAN_KPIS } from '#shared/kpi/kpi.model.js';
import { DIMENSIONS } from './dimensions.constant.js';
export const MEASURES = [...DIMENSIONS, ...CATMAN_KPIS, 'sales_with_or_without_tax', 'numerator_key'];
//# sourceMappingURL=measures.constant.js.map